import React, {useState} from 'react';
import * as S from './Loader.styles';
import LineLoader from '../../../../../../stories/core-components/LineLoader/LineLoader';

const Loader = (props:{count ?: number}) => {

  if(props && props.count){
    let loaderView =[];
    for(let i=0;i< props.count;i++){
     loaderView.push(
      <S.LoaderColumn key={i}>
      <LineLoader width="75%" height="1.6rem" />
      <LineLoader width="50%" height="1.6rem" />
      <LineLoader width="75%" height="200px" />
    </S.LoaderColumn>
   
     )
    }
    return(  <S.Loader>
      {
        loaderView
      }
    </S.Loader>
      )
   
  }
  return (
    <S.Loader>
      <S.LoaderColumn>
        <LineLoader width="75%" height="1.6rem" />
        <LineLoader width="50%" height="1.6rem" />
        <LineLoader width="75%" height="200px" />
      </S.LoaderColumn>
      <S.LoaderColumn>
        <LineLoader width="75%" height="1.6rem" />
        <LineLoader width="50%" height="1.6rem" />
        <LineLoader width="75%" height="200px" />
      </S.LoaderColumn>
      <S.LoaderColumn>
        <LineLoader width="100%" height="1.6rem" />
        <LineLoader width="50%" height="1.6rem" />
        <LineLoader width="100%" height="20rem" />
        <LineLoader width="100%" height="5rem" />
      </S.LoaderColumn>
    </S.Loader>
  );
};

export default Loader;
